import { CommonLayout } from "@design-system/layouts";
import { Outlet, useLoaderData } from "@remix-run/react";

export default function CommonLayoutRoute() {
  useLoaderData();

  return (
    <CommonLayout>
      <Outlet />
    </CommonLayout>
  );
}
